import type { NavigateFunction } from "react-router-dom";

// Глобальная функция навигации для использования вне React-компонентов
let navigateRef: NavigateFunction | null = null;

export const setNavigate = (navigate: NavigateFunction) => {
  navigateRef = navigate;
};

export const globalNavigate = (to: string) => {
  if (navigateRef) {
    navigateRef(to);
  } else {
    // Fallback если navigate ещё не инициализирован
    window.location.href = to;
  }
};
